var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOutCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.01094 1.2C5.01094 0.537259 5.5482 0 6.21094 0C6.87368 0 7.41094 0.537258 7.41094 1.2V2.4H17.0109V1.2C17.0109 0.537259 17.5482 0 18.2109 0C18.8737 0 19.4109 0.537258 19.4109 1.2V2.4H20.6109C22.5992 2.4 24.2109 4.01178 24.2109 6V19.2218C23.6631 19.8796 23.6025 20.8075 24.0316 21.5252C23.9778 21.689 23.9125 21.8476 23.8367 22H20.2109C19.1064 22 18.2109 22.8954 18.2109 24H3.81094C1.82271 24 0.210938 22.3882 0.210938 20.4V6C0.210938 4.01178 1.82271 2.4 3.81094 2.4H5.01094V1.2ZM9.81094 12C9.1482 12 8.61094 12.5373 8.61094 13.2C8.61094 13.8627 9.1482 14.4 9.81094 14.4H18.2109C18.8737 14.4 19.4109 13.8627 19.4109 13.2C19.4109 12.5373 18.8737 12 18.2109 12H9.81094ZM6.21094 16.8C5.5482 16.8 5.01094 17.3373 5.01094 18C5.01094 18.6627 5.5482 19.2 6.21094 19.2H13.4109C14.0737 19.2 14.6109 18.6627 14.6109 18C14.6109 17.3373 14.0737 16.8 13.4109 16.8H6.21094Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2109 24H29.2109M29.2109 24L25.7494 20.5M29.2109 24L25.7494 27.5",
    stroke: "#777E91",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutCalendar);
export default __webpack_public_path__ + "static/media/check-out-calendar.8c5ffc7e6510b4b45c28205c173a79a6.svg";
export { ForwardRef as ReactComponent };